import { render, staticRenderFns } from "./ContactListEdit.vue?vue&type=template&id=1c022710"
import script from "./ContactListEdit.vue?vue&type=script&lang=js"
export * from "./ContactListEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports